<template>
    <div class="text-center mt-4" id="contact">
        <a class="btn btn-xl bg-info btn-outline-light shadow" title="Contacta con nosotros"
            href="https://m.me/tecdevweb" target="_blank" aria-label="Contacta con nosotros">
            <i class="fas fa-message me-2"></i>
            Contáctanos
        </a>
    </div>
</template>